module.exports = __webpack_public_path__ + "static/media/GDSC.6326719c.png";